import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { APIUrl } from '../../app-service-routing';
import { AdminPanelService } from '../../services/admin-panel.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-category-functinalites',
  templateUrl: './category-functinalites.component.html',
  styleUrls: ['./category-functinalites.component.scss']
})

export class CategoryFunctinalitesComponent implements OnInit {
  label: any;
  button: any;
  registerForm: FormGroup;
  submitted = false;
  checked = false;
  disabled = false;
  add_category_list: boolean = true; list_category_list: boolean = false;
  list_data: any;
  displayedColumns: string[] = ['categoryName', 'iconName','enable', 'Action'];
  dataSource;
  // email = new FormControl('', [Validators.required, Validators.email]);
  constructor(private adminpanelservice: AdminPanelService, private formBuilder: FormBuilder) { }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    this.createform();
    this.categorylisting();
  }
  createform() {
    this.registerForm = this.formBuilder.group({
      categoryName: ['', Validators.required],
      iconName: [''],
    });
  }
  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  onSubmit() {
    debugger;
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    } else {
      console.log(this.registerForm.value)
      this.add_edit_delete(this.registerForm.value)
    }
  }
  add_edit_delete(value) {
    this.adminpanelservice.updateResultSet(APIUrl.addcategoryUrl, value).subscribe(response => {
      console.log(response);
      this.categorylisting()
      this.list_category();
      this.createform();
    }, error => {
    });
  }


  categorylisting() {
    this.adminpanelservice.getReseultSetList(APIUrl.categoryallUrl).subscribe(response => {
      this.list_data = response
      this.dataSource = new MatTableDataSource<PeriodicElement>(this.list_data);
      this.dataSource.paginator = this.paginator;
    }, error => {
    });
  }


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // Add_category
  add_category() {
    this.createform();
    this.button = 'Add'
    this.label = "Add Catgeory";
    this.list_category_list = true;
    this.add_category_list = false;
  }
  //List_Category
  list_category() {
    this.add_category_list = true;
    this.list_category_list = false;
  }

  edit_category(data) {
    console.log(data)
    this.button = 'Edit'
    this.registerForm = this.formBuilder.group({
      categoryName: [data.categoryName],
      iconName: [data.iconName],
      categoryID: [data.categoryID],
      isActive: [data.isActive]
    });
    this.label = "Edit Catgeory";
    this.list_category_list = true;
    this.add_category_list = false;
  }

  delete_category(data) {
    debugger;
    this.registerForm = this.formBuilder.group({
      categoryName: [data.categoryName],
      iconName: [data.iconName],
      categoryID: [data.categoryID],
      isActive: [data.isActive]
    });
    this.add_edit_delete(this.registerForm.value)
  }

}

// Sample data
export interface PeriodicElement {
  categoryName: string;
  enable:string;
  iconName: string;
  Action: string;
}
